<template>
    
    <div class="row">
      
        <div class="col-12">
            <div class="card">
               
                <div class="card-body">
                    <div class="row">
                         
                        <div class="col-12">
                            
                            <router-link class="btn btn-sm btn-primary-rgba" :to="{name:'route-tag-edit', params:{'id':'00000000-0000-0000-0000-000000000000'}}">
                                <i class="feather icon-plus"></i> Nuovo tag
                            </router-link>
                            <hr />
                            <table ref="table" id="list-tag-table" class="table w-100"></table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- /.col -->
    </div>
        
    
</template>

<script>
   
    export default {
        computed: {
           
        },
        components: {
           
        },
        data() {
            return {
            
            }
     
        },
        name: 'InheritancesList',
        beforeMount() {
            var me = this;
            window.ViewMessage = function (id) {
                me.$router.push({
                    name: "route-message",
                    params: {id:id},
                        replace: true
                    });
              
                return false;
            };
            
           
           
        },

        mounted() {
            setTimeout(
            this.loaddata,200);
        },
        methods: {
            edit: function (id) {
  this.$router.push({name:'route-tag-edit', params:{id:id}});
                return false;
            },
            loaddata: function () {

                window["EditAction"] = this.edit;
                var me = this;

                 var edit = "M";
                if (me.$refs && me.$refs.edit && me.$refs.edit.outerHTML) {
                    edit = me.$refs.edit.outerHTML 
                }

                  var remove = "C";
                if (me.$refs && me.$refs.remove && me.$refs.remove.outerHTML) {
                    remove = me.$refs.remove.outerHTML 
                }
                if ($.fn.DataTable.isDataTable('#list-tag-table')) {
                    $('#list-tag-table').DataTable().destroy();

                }
             
            var $table = $('#list-tag-table').DataTable({
                "processing": true,
                "serverSide": true,
                "ajax": {
                    "url": window.SETTINGS.apiUrl + "/tag/list",
                    'type': 'POST',
                     "data": function (d) {
                         return JSON.stringify(d);
                    },
                    
                    'beforeSend': function (request) {
                        request.setRequestHeader("Authorization", "Bearer " + me.$store.state.user.token);
                        request.setRequestHeader("Content-Type", "application/json");
                    }
                },

                "columns": [
                    {
                        "data": "tagTypeId", "name": "tagId", "title": "Tag",
                        "render": function (data, type, row, meta) {
//                            var output =
//                                `<div class="row">
//<div class="col">
//<h5><a href='#' ">${row.description}</a></h5>

//</div>`
                          
                            return row.description;
                        }
                    },
                   {
            className: "text-right",
            data: "tagId",
            name: "tagId",
            title: "Azioni",
            render: function (data, type, row, meta) {
              
            if(row.type.reserved){
              return   `<div class="button-list"><button type="button" class="btn btn-info-rgba" data-id="${data}" onClick="window.EditAction('${data}')"><i class="feather icon-info"></i></button>`;
            }
              return `<div class="button-list"><button type="button" class="btn btn-success-rgba" data-id="${data}" onClick="window.EditAction('${data}')"><i class="feather icon-edit-2"></i></button>
                                    <button type="button" class="btn btn-danger-rgba remove-action"  data-id="${data}"><i class="feather icon-trash"></button></div>`;
            },
          },

                ]


            });

                $table.on('select', function (e, dt, type, indexes) {

                })
            }
        }
    };
</script>
